import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { StudentTestsComponent } from '../../../../../shared/tables/student-tests/student-tests.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-evaluation-test',
  standalone: true,
  imports: [CommonModule, StudentTestsComponent, TranslateModule],
  templateUrl: './evaluation-test.component.html',
  styleUrl: './evaluation-test.component.css',
})
export class EvaluationTestComponent {
  activeTab: 'active' | 'archived' = 'active';
}
